import React, { useEffect, useRef, useState } from 'react';
import { Flexbox } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import ThemeLogo from '../theme/ThemeLogo';
import './DropdownFilter.scss';

const DropdownFilter = ({ heading, children, contentClassName, selected, onRemove }) => {
  const [showContent, setShowContent] = useState(false);
  const dropdownRef = useRef(null);

  function handleShowContent() {
    setShowContent(prev => !prev);
  }

  function handleRemove(event) {
    event.stopPropagation();
    onRemove?.();
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowContent(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className='dropdownfilter_wrapper'>
      <Flexbox gap='0.5rem' onClick={handleShowContent}>
        <ThemedText.P>{heading}</ThemedText.P>
        {selected ? (
          <ThemeLogo icon={'dropdownCross'} onClick={handleRemove} />
        ) : (
          <svg xmlns='http://www.w3.org/2000/svg' width='5' height='4' viewBox='0 0 5 4' fill='none'>
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M2.22227 3.38072L0 1.07606L0.555468 0.5L2.5 2.51663L4.44453 0.5L5 1.07606L2.77773 3.38072C2.70407 3.45709 2.60417 3.5 2.5 3.5C2.39583 3.5 2.29593 3.45709 2.22227 3.38072Z'
              fill='#818181'
            />
          </svg>
        )}
      </Flexbox>
      {showContent && (
        <div className={`dropdownfilter_content ${contentClassName}`} onClick={handleShowContent}>
          {React.isValidElement(children) ? React.cloneElement(children, { onSelect: handleShowContent }) : children}
        </div>
      )}
    </div>
  );
};

export default DropdownFilter;
